type FormatUrl = (url: string) => string
export const formatUrl: FormatUrl = url => {
    return url.replace(/\/$/, '')
}
